module.exports = {
  defaultLocale: 'en',
  defaultNS: 'common',
  locales: ['en'],
  pages: {
    '*': ['common', 'notifications'],
    '/company/*': ['rbac'],
    '/job-apply/*': ['jobs'],
    '/jobs': ['jobs'],
    '/talent/profile': ['profile'],
  },
};
